import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Frame, ScalingContainer } from "../../../../AppStyled";

import { handleBet } from "../../../../redux/actions/postActions";
import { ReactComponent as MinusSVG } from "../../../../svg/minus.svg";
import { ReactComponent as PlusSVG } from "../../../../svg/plus.svg";

// SetBetDiv,
import { SetBetBox, Text, Ops, Opr, SetBetBtn, BackBtn } from "./SetBetStyled";
import useSound from "use-sound";

import confirmSound from "../../../../audio/confirm.mp3";
import closeSound from "../../../../audio/goBack.mp3";

import useBetOperations from "../useBetOperations";

export default function SetBet({
  handleAbove,
  unBlur,
  handleNotification,
  toFix,
  minBet,
  maxBet,
  currency,
  h,
  scrollable,
  sound,
  volume,
  prec
}) {
  const st = useSelector((s) => s);
  // const { sound } = st.userSettings;
  const dispatch = useDispatch();
  const [value, setvalue] = useState(st.bet);
  const [inputValue, setinputValue] = useState(value);
  // const handleNotification = () => {};
  const [closeSFX] = useSound(closeSound, { volume });
  const [confirmSFX] = useSound(confirmSound, { volume });

  const [
    useBet,
    plus,
    minus,
    multiply,
    divide,
    handleButtonPress,
    handleButtonRelease,
  ] = useBetOperations(
    value,
    false,
    sound,
    handleNotification,
    toFix,
    minBet,
    maxBet,
    currency,
  );
  useEffect(() => {
    setvalue(useBet);
    setinputValue(useBet);
  }, [useBet]);

  

  const handleChange = (e) => {
    // // const reg = /^-?\d+\.?\d*$/;
    const reg = /^\d*\.?\d*$/;

    // const q = e.target.value;

    // if (reg.test(q) || q === "") {
    //   // setvalue(q);
    //   setinputValue(q);
    // }

    const value = e.target.value;
    if (reg.test(value) || value === "") {
      let modifiedValue = value.replace(/,/g, ".");
  
      const [integerPart, decimalPart] = modifiedValue.split(".");
  
      if (prec >= 0) {
        if (decimalPart) {
          modifiedValue = `${integerPart}.${decimalPart.slice(0, prec)}`;
        }
      }
      setinputValue(modifiedValue);
    }
  };

  const handleBlur = (e) => {
    const n = e.target.value;
    const max = maxBet;
    const min = minBet.toFixed(toFix);
    if (+n < +min || n === "" || n === ".") {
      handleNotification(`Minimum bet limit is ${min} ${currency}`);
      setinputValue(min);
      setvalue(min);
    } else if (+n >= +max) {
      const maxFixed = max.toFixed(toFix)
      handleNotification(`Maximum bet limit is ${maxFixed} ${currency}`);
      setinputValue(maxFixed);
      setvalue(maxFixed);
    } else {
      setinputValue(n);
      setvalue(n);
    }
  };
  const notifyText = false;

  const [playPress, setplayPress] = useState(false);
  const [playUnpress, setplayUnpress] = useState(false);
  const [plusPress, setPlusPress] = useState(false);
  const [minusPress, setMinusPress] = useState(false);

  const [halfAnim, sethalfAnim] = useState(false);
  const [multAnim, setmultAnim] = useState(false);
  const [multAnim5, setmultAnim5] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setplayPress(false);
      setplayUnpress(false);
    }, 200);
  }, [playPress]);
  const [clicked, setclicked] = useState(false);
  return (
    <Frame
      className="Frame"
      unBlur={unBlur}
      opacity="true"
      scrollable={scrollable}
    >
      <ScalingContainer className="ScalingContainer" h={h}>
        <SetBetBox>
          <Text>
            <p  style={{ textTransform:'none' }}>{currency}</p>
            <input
              type="text"
              maxLength="10"
              value={inputValue}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          </Text>
          <Ops>
            <Opr
              onClick={() => {
                sethalfAnim(true);
                setTimeout(() => {
                  sethalfAnim(false);
                  divide();
                }, 300);
              }}
              anim={halfAnim}
            >
              <div className="white" />
              1/2
            </Opr>
            <Opr
              onClick={() => {
                setmultAnim(true);
                setTimeout(() => {
                  setmultAnim(false);
                  multiply();
                }, 300);
              }}
              anim={multAnim}
            >
              <div className="white" />
              2x
            </Opr>
            <Opr
              onClick={() => {
                setmultAnim5(true);
                setTimeout(() => {
                  setmultAnim5(false);
                  multiply(5);
                }, 300);
              }}
              anim={multAnim5}
            >
              <div className="white" />
              5x
            </Opr>
            <Opr
              onClick={minus}
              minusPress={minusPress}
              onTouchStart={() => {
                !notifyText && setMinusPress(true);
                handleButtonPress("acceleratableMinus");
              }}
              onTouchEnd={() => {
                setMinusPress(false);
                handleButtonRelease();
              }}
              onMouseDown={() => {
                !notifyText && setMinusPress(true);
                handleButtonPress("acceleratableMinus");
              }}
              onMouseUp={() => {
                setMinusPress(false);
                handleButtonRelease();
              }}
              onMouseLeave={() => {
                setMinusPress(false);
                handleButtonRelease();
              }}
            >
              <div className="white" />

              <MinusSVG />
            </Opr>
            <Opr
              onClick={plus}
              plusPress={plusPress}
              onTouchStart={() => {
                !notifyText && setPlusPress(true);
                handleButtonPress("acceleratablePlus");
              }}
              onTouchEnd={() => {
                setPlusPress(false);
                handleButtonRelease();
              }}
              onMouseDown={() => {
                !notifyText && setPlusPress(true);
                handleButtonPress("acceleratablePlus");
              }}
              onMouseUp={() => {
                setPlusPress(false);
                handleButtonRelease();
              }}
              onMouseLeave={() => {
                setPlusPress(false);
                handleButtonRelease();
              }}
            >
              <div className="white" />
              <PlusSVG />
            </Opr>
          </Ops>
          <SetBetBtn
            playPress={playPress}
            playUnpress={playUnpress}
            onClick={() => {
              if (sound && !clicked) confirmSFX();
              setclicked(true);
              setplayPress(true);
              setTimeout(() => {
                setplayUnpress(true);
              }, 100);
              setTimeout(() => {
                setplayPress(false);
                dispatch(handleBet(value));
                handleAbove(false);
              }, 200);
            }}
          >
            <div className="white" />
            Set
          </SetBetBtn>
          <BackBtn
            onClick={() => {
              if (sound) closeSFX();
              handleAbove(false);
            }}
          >
            Back
          </BackBtn>
        </SetBetBox>
      </ScalingContainer>
    </Frame>
  );
}
